const API_ROOT = "https://dev.qsd-np.qualcomm.com"

export const fetchData = async (path) => {
    const response = await fetch(`${API_ROOT}${path}`)
    if (!response.ok) {
        throw new Error(`Failed to Fetch data from ${API_ROOT}${path}`)
    }
    return response.json();
};

export const postFormData = async (path, formData) => {
    try {
        const response = await fetch(`${API_ROOT}${path}`, {
            method: "POST",
            body: formData
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to post form data to ${API_ROOT}${path}: ${errorText}`);
        }
        return response.json();
    } catch (error) {
        return { error: error.message };
    }
};


export const postData = async (path, data) => {
    try {
        const response = await fetch(`${API_ROOT}${path}`, {
            method: "POST",
            headers: {
                "Content-Type": "application/json"
            },
            body: JSON.stringify(data),
        });
        if (!response.ok) {
            const errorText = await response.text();
            throw new Error(`Failed to post data to ${API_ROOT}${path}: ${errorText}`);
        }
        return response.json();
    } catch (error) {
        return { error: error.message };
    }
};
